import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Lightbulb, Home, Zap } from "lucide-react";

// Assuming MoralStoriesData is imported correctly from "./MoralStoriesData"
import {MoralFullStoriesData} from "./MoralStoriesData";

const Moraldetailstory = () => {
  const { moralId } = useParams();
  const navigate = useNavigate();

  const story = MoralFullStoriesData.find(
    (item) => String(item.id) === String(moralId)
  );

  if (!story) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-gray-100 p-6">
        <h2 className="text-4xl font-bold text-red-500 mb-4">Story not found!</h2>
        <button
          onClick={() => navigate(-1)}
          className="px-5 py-3 bg-blue-600 text-white rounded-xl shadow hover:bg-blue-700 transition"
        >
          Go Back
        </button>
      </div>
    );
  }

return (
  <div className="min-h-screen w-full bg-gradient-to-br from-yellow-50 via-teal-50 to-pink-50 font-sans">

    {/* Full-width Header */}
    <header className="w-full px-6 py-5 flex justify-between items-center border-b-4 border-dashed border-teal-300 shadow-md">
      <button
        onClick={() => navigate(-1)}
        className="flex items-center gap-2 text-xl font-bold text-teal-700 hover:text-teal-900 transition"
      >
        <Home className="w-6 h-6" />
        Back to Stories
      </button>
      {/* <Zap className="w-10 h-10 text-pink-500" /> */}
    </header>

    {/* FULL SCREEN CONTENT */}
    <section className="w-full py-10 px-4 md:px-8 lg:px-12">

      {/* Title - full width */}
      <h1 className="text-4xl md:text-5xl font-black text-purple-700 text-center mb-8">
        {story.title.replace(/[^a-zA-Z\s]/g, "")}
      </h1>

      {/* FULL WIDTH STORY CONTAINER */}
      <div className="w-full bg-white shadow-2xl border-t-8 border-pink-400 rounded-xl overflow-hidden">

        <h2 className="text-3xl font-bold text-pink-600 p-6 border-b-4 border-dashed border-gray-100">
          Read the Full Tale!
        </h2>

        {/* FULL-WIDTH GRID with 3 or 4 columns on large screens */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 w-full">
          {story.fullStory.map((item, index) => (
            <div
              key={index}
              className={`flex flex-col gap-3 p-5 transition duration-300 border-b border-r border-gray-100 ${
                index % 2 ? "bg-gray-50 hover:bg-gray-100" : "bg-white hover:bg-gray-50"
              }`}
            >
              
              {/* Image Container: INCREASED HEIGHT FOR BIGGER IMAGE */}
              <div className="w-full h-64 rounded-lg overflow-hidden shadow-lg border-2 border-purple-200">
              <img
                src={item.img}
                alt={`${story.title} - sentence ${index + 1}`}
                // CHANGE THIS LINE
                className="w-full h-full object-contain" // Ensures the entire image is visible
                loading="lazy"
              />
            </div>
              {/* Text */}
              <p className="text-gray-700 text-lg leading-snug font-medium pt-2">
                <span className="font-bold text-pink-600 mr-1">Step {index + 1}:</span>
                {item.text}.
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* MORAL – Full width box for prominence */}
      <div className="bg-yellow-200 p-8 mt-10 shadow-xl border-l-8 border-yellow-500 flex gap-4 items-start w-full rounded-xl">
        <Lightbulb className="w-12 h-12 text-orange-600 mt-1 flex-shrink-0" />
        <div>
          <h3 className="text-2xl font-black text-orange-700">The Big Lesson:</h3>
          <p className="text-xl md:text-2xl text-orange-800 font-semibold mt-1">
            {story.moral}
          </p>
        </div>
      </div>
    </section>
  </div>
);

};

export default Moraldetailstory;